import ReactGA from 'react-ga';

export default function InitAnalytics() {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, {
    testMode: process.env.REACT_APP_GA_TEST_MODE,
  });
  ReactGA.pageview(window.location.pathname + window.location.search);
}
